import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './ECardSharePanel.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import ExportButton from '../../../../Components/Button/ExportButton';
import ECardMoveFileToHealthDocumentationModal from '../ECardMoveFileToHealthDocumentation/ECardMoveFileToHealthDocumentationModal';
import { FileToShare } from '../ECard/ECard';
import { ECardType } from '../../Enums/ECardType.enum';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	filesToShare: FileToShare[];
	patientId: string;
	targetPatientId?: string;
	onShareSuccess: () => void;
	type: ECardType;
	/**
	 * Sends the selected files to a new Dočasné úložiště (MZČR) package - the patient card then
	 * switches to "Nová zásilka" (design Z1/Z2). Only for the health documentation.
	 */
	onSendFiles?: () => void;
}

const ECardSharePanel: React.FC<Props> = ({
	filesToShare,
	patientId,
	targetPatientId,
	onShareSuccess,
	type,
	onSendFiles,
}) => {
	const { t } = useTranslation();
	const [
		isMoveFilesToHealthDocumentationOpen,
		setIsMoveFilesToHealthDocumentationOpen,
	] = useState(false);

	const title = useMemo(() => {
		let title = '';
		switch (true) {
			case filesToShare.length === 1:
				title += `${t('component.eCard.selected.one')}: ${
					filesToShare.length
				} ${t('component.eCard.file.one')}`;
				break;
			case filesToShare.length === 2 ||
				filesToShare.length === 3 ||
				filesToShare.length === 4:
				title += `${t('component.eCard.selected.two')}: ${
					filesToShare.length
				} ${t('component.eCard.file.two')}`;
				break;
			default:
				title += `${t('component.eCard.selected.many')}: ${
					filesToShare.length
				} ${t('component.eCard.file.many')}`;
				break;
		}
		return title;
	}, [filesToShare]);

	const afterShareSuccess = () => {
		setIsMoveFilesToHealthDocumentationOpen(false);
		onShareSuccess();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.selected}>{title}</div>
				<div className={styles.actions}>
					{targetPatientId && (
						<ExportButton
							title={
								type === ECardType.PATIENT_E_CARD
									? 'component.eCard.moveToHealthDocumentation'
									: 'component.eCard.moveToECard'
							}
							onClick={() => setIsMoveFilesToHealthDocumentationOpen(true)}
							isDisabled={filesToShare.length < 1}
							disabledAlert='component.eCard.moveToHealthDocumentationDisabledMessage'
						/>
					)}
					{type === ECardType.HEALTH_DOCUMENTATION && onSendFiles && (
						<ExportButton
							title='component.eCard.sendViaTemporaryStorage'
							icon='send'
							onClick={onSendFiles}
							isDisabled={filesToShare.length < 1}
							disabledAlert='component.eCard.moveToHealthDocumentationDisabledMessage'
						/>
					)}
				</div>
			</div>
			{isMoveFilesToHealthDocumentationOpen && targetPatientId && (
				<ECardMoveFileToHealthDocumentationModal
					opened
					isPatientsConsentRequired={type === ECardType.HEALTH_DOCUMENTATION}
					targetPatientId={targetPatientId}
					patientId={patientId}
					onClose={() => setIsMoveFilesToHealthDocumentationOpen(false)}
					filesToShare={filesToShare}
					onSuccess={afterShareSuccess}
				/>
			)}
		</>
	);
};

export default ECardSharePanel;
